import axios from '@utils/axios-client'

export async function fetchPremiumVideos (params: any = {}) {
  const response = axios.get('/api/v1/PremiumVideo/GetTopPage', { params })
  return (await response).data
}

export async function fetchRecentlyPostedVideos (params: any = {}) {
  const response = axios.get('/api/v1/VideoGoLiver/GetRecentlyPosted', { params })
  return (await response).data
}

export async function fetchNewIntroductionVideos (params: any = {}) {
  const response = axios.get('/api/v1/Store/GetNewIntroduction', { params })
  return (await response).data
}

export async function getTopPageVideos (params: any = {}) {
  const response = axios.get('/api/v1/Videos/GetTopPage', { params })
  return (await response).data
}

export async function getTopPageVideoGoLiver (params: any = {}) {
  const response = axios.get('/api/v1/VideoGoLiver/GetTopPage', { params })
  return (await response).data
}

export async function getHistoryTopPageVideos (params: any = {}) {
  const response = axios.get('/api/v1/VideoViewingLog/GetHistoryTopPage', { params })
  return (await response).data
}

export async function getVideoByFoodCateGroup (params: any = {}) {
  const response = axios.get('/api/v1/Videos/GetByFoodCateGroup', { params })
  return (await response).data
}

export async function getVideoGoLiverById (id: string, params: any = {}) {
  const response = axios.get(`/api/v1/VideoGoLiver/${id}`, { params })
  return (await response).data
}

export async function createVideoViewingLog (data: any = {}) {
  const response = axios.post('/api/v1/VideoViewingLog/Create', data)
  return (await response).data
}
